<div class="container">
    <div class="search-container">
        <mat-form-field color="primary">
            <input #searchSession
                    matInput
                   type="text"
                   maxlength="255"
                   placeholder="{{ 'Filter' | translate }}">
            <mat-icon matSuffix>search</mat-icon>
        </mat-form-field>
    </div>
    <div class="session-list-wrapper">
      <div class="session-list"
           *ngIf="!isLoading"
           cdkDropList
           [cdkDropListDisabled]="false">
        <ng-container *ngFor="let sessionRow of sessionRows$ | async; let i = index">
          <div cdkDrag
               [cdkDragData]="{ sessionId: sessionRow.id }"
               class="session-item">
            <div class="drag-handle"
                 cdkDragHandle>
              <mat-icon>drag_indicator</mat-icon>
            </div>
            <sessions-session-preview [sessionRow]="sessionRow"
                                      [organization]="organization">
            </sessions-session-preview>
          </div>
        </ng-container>
      </div>

      <center-loader class="paginator-data-placeholder min-h-side-loader" *ngIf="isLoading"></center-loader>
    </div>
    <mat-paginator #paginator
                   [class.hidden]="sessionDataSource?.totalItems == 0"
                   hidePageSize
                   [pageSize]="itemsPerPage"
                   [length]="sessionDataSource.totalItems"
                   showFirstLastButtons>
    </mat-paginator>
</div>
